import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  selector: 'app-company-selection-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzModalModule, ReactiveFormsModule, NzRadioModule],
  templateUrl: './company-selection-modal.component.html',
  styleUrl: './company-selection-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CompanySelectionModalComponent {

  companies: any[] = [];
  form!: FormGroup;

 constructor(
   @Inject(NZ_MODAL_DATA) public data: any,
   private fb: FormBuilder,
   private modal: NzModalRef
 ) {
    this.companies = data?.companies || [];
 }

 ngOnInit(): void {
  console.log('companies componente',this.data);
   this.form = this.fb.group({
     selectedCompany: [null]
   });
 }

 confirmSelection(): void {
   const selected = this.form.value.selectedCompany;
   if (selected) {
     this.modal.close(selected);
   }
 }
}
